import React, { useEffect } from "react";
import { Button } from "primereact/button";
import {
  getCategory,
  getSubCategory,
} from "../../store/AsyncMethods/CategoryMethod";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { RESET_ERROR, RESET_SUCCESS } from "../../store/Types/AuthTypes";
import { useLocation, useNavigate } from "react-router-dom";
import { getProducts } from "../../store/AsyncMethods/ProductMethod";
import { getSales } from "../../store/AsyncMethods/SalesMethod";
import { RESET_SPECIFIC_SALES } from "../../store/Types/SalesTypes";
import { useTranslation } from "react-i18next";
import { getCashReceipt } from "../../store/AsyncMethods/CashReceiptMethod";
import PaymentReceiptTable from "./PaymentReceiptTable";
import { getPaymentReceipt } from "../../store/AsyncMethods/PaymentReceiptMethod";
import {
  getPurchase,
  getUnpaidPostedInvoices,
  getUnpaidPostedPurchases,
} from "../../store/AsyncMethods/PurchaseMethod";

export default function PaymentReceiptMain() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const { success, error, user } = useSelector((state) => state.AuthReducer);

  useEffect(() => {
    if (success) {
      toast.success(success);
      dispatch({ type: RESET_SUCCESS });
    }
  }, [success]);

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch({ type: RESET_ERROR });
    }
  }, [error]);

  useEffect(() => {
    if (user) {
      dispatch(getPaymentReceipt());
      dispatch(getUnpaidPostedPurchases());
      dispatch(getPurchase());
    }
  }, []);

  useEffect(() => {
    dispatch({ type: RESET_SPECIFIC_SALES });
  }, [location.pathname]);

  return (
    <div className="">
      <div className="flex justify-end">
        <Button
          label={t("Add AP Receipt")}
          icon="pi pi-plus"
          className="p-primary-btn"
          onClick={() =>
            navigate(
              user?.role_id == 1 ? "/add-payment-receipt" : "/add-cash-receipt"
            )
          }
        />
      </div>
      <div className="my-4">
        <PaymentReceiptTable />
      </div>
    </div>
  );
}
